import React, { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import Icon from 'shared/components/Icon';
import { FilterViewType } from 'shared/types';

type CustomFilterViewProps = {
  filteredViews?: any;
  toggleDrawer: (value: boolean) => void;
  selectedFilter?: FilterViewType;
  onChange: (filterView: FilterViewType) => void;
  onDelete: (filterId: string, filterName: string) => void;
  setEditFilterViewAnchor?: (
    val: SetStateAction<HTMLDivElement | null>,
  ) => void;
  setFilterViewName?: (value: string) => void;
  editFilterViewRef?: any;
  groupBySurvey?: boolean;
  isFetchingFilterViews?: boolean;
};

function CustomFilterView(props: CustomFilterViewProps) {
  const {
    filteredViews,
    toggleDrawer,
    selectedFilter,
    onChange,
    onDelete,
    setEditFilterViewAnchor,
    setFilterViewName,
    isFetchingFilterViews,
    editFilterViewRef,
    groupBySurvey,
  } = props;
  const { t } = useTranslation();

  const getFilterView = (filterView) => {
    return (
      <div
        className={`drawer-menu-item filter-view ${
          filterView.id === selectedFilter?.id ? 'selected-filter' : ''
        }`.trim()}
        onClick={() => {
          toggleDrawer(false);
          onChange(filterView);
        }}
        key={filterView.id}
      >
        <span>{filterView.name}</span>
        <div className="d-menu-ic-holder">
          <Icon
            fill="#fff"
            glyph="edit"
            height={13}
            width={13}
            tabIndex={0}
            role="button"
            aria-describedby="filter-view-edit-popover"
            onClick={() => {
              setEditFilterViewAnchor?.(editFilterViewRef.current);
              setFilterViewName?.(filterView.name);
            }}
          />
          <Icon
            fill="#fff"
            glyph="delete"
            height={13}
            width={13}
            onClick={() => {
              onDelete(filterView?.id || '', filterView.name);
            }}
            onKeyDown={(e) => {
              // uncommenting this will work for Enter press but tabIndex won't work
              // e.preventDefault();
              if (e.keyCode == 13) {
                onDelete(filterView?.id || '', filterView.name);
              }
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {isFetchingFilterViews ? (
        Array(3)
          .fill(0)
          .map((idx) => (
            <p key={idx} style={{ margin: '10px' }}>
              <Skeleton width="80%" height={24} />
            </p>
          ))
      ) : (
        <>
          {groupBySurvey
            ? filteredViews &&
              Object.keys(filteredViews)?.length > 0 && (
                <>
                  <div className="filter-view-heading">
                    {`${t('responses.filter_views')}`}
                  </div>
                  <div className="filter-views-container">
                    {Object.keys(filteredViews)?.map((surveyName) => (
                      <>
                        <p className="fv-gp-head">{surveyName}</p>
                        {filteredViews[surveyName].map((filterView) =>
                          getFilterView(filterView),
                        )}
                      </>
                    ))}
                  </div>
                </>
              )
            : filteredViews &&
              filteredViews?.length > 0 && (
                <>
                  <div className="filter-view-heading">
                    {`${t('responses.filter_views')}`}
                  </div>
                  {filteredViews.map((filterView) => getFilterView(filterView))}
                </>
              )}
        </>
      )}
    </>
  );
}

export default CustomFilterView;
